<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.orderTags.editOrderTag') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/tagi-zamowien')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          {{ $t('ui.saveChanges') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="tag-edit-form" tag="form" v-if="loaded">
              <div class="form-group">
                <label for="name">
                  {{ $t('settings.orderTags.tagName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('settings.orderTags.tagColor') }}:
                </label>

                <compact-picker
                  v-model="color" />
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('settings.orderTags.tagDescription') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="description"
                  v-slot="{ errors }">
                  <d-textarea
                    :value.prop="description"
                    :state="errors.length ? 'invalid' : null"
                    v-model="description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>

            <div v-if="!loaded" class="pb-3 pt-3 text-center">
              {{ $t('ui.dataLoading') }}&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '../../utils/FormUtils.js';
import { Compact } from 'vue-color';

export default {
  name: 'tag-edit',
  components: {
    'compact-picker': Compact
  },
  data() {
    return {
      id: 0,
      name: '',
      color: '',
      description: '',
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    FormUtils.loadItemData(this, {
      method: 'get',
      endpointBase: '/orders/tags/item/',
      instanceFields: ['name', 'color', 'description'],
      loadedKey: 'loaded'
    });
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['tag-edit-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/orders/tags/update/' + this.id,
        formData: {
          name: this.name,
          color: this.color.hex ? this.color.hex : this.color,
          description: this.description
        },
        successTitle: this.$t('settings.orderTags.editOrderTagSuccessTitle'),
        successText: this.$t('settings.orderTags.editOrderTagSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.orderTags.editOrderTagErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/tagi-zamowien')
        }
      });
    }
  }
};
</script>
